
















































import { Component } from 'vue-property-decorator'
import BaseDialog from '@/utils/dialog-control'
import $Api from '@api'
import { translate } from '@/utils/filters'

@Component
export default class CompareDialog extends BaseDialog {
    form = {
        bankId: '',
        channelId: '',
        bankCode: '',
        status: '',
        noticeStatus: '',
        thridBankName: '',
        id: ''
    }
    banks = {};
    channels = {};
    paymentTypes = {};
    rules = {
        channelId: { required: true, message: translate('channel.NoNull'), trigger: 'change' },
        bankId: { required: true, message: translate('bank.NoNull'), trigger: 'change' },
        status: { required: true, message: translate('notice.StatusNoNull'), trigger: 'change' }
    }

    async loadData() {
        $Api.channelService.queryChannelDropdown().subscribe(data => {
            this.channels = data
        })
        $Api.channelService.queryAbroadBankDropdown().subscribe(data => {
            this.banks = data
        })
    }

    create() {
        return $Api.channelService.addRouteControl(this.form)
    }

    update() {
        return $Api.channelService.updateRouteControl(this.form)
    }

    onOpen() {
        this.loadData()
    }

    onClose() {

    }
}
